import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import {number_format,number_input_format, getiOS} from '../helper/format';

export default class CallChatpopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false
        };
    }
    Open(type, data)
    {
      this.appl_type = type;
      this.setState({
          open: true,
          data: data
      });
      console.log(data);
    }
    Close()
    {
        this.setState({
            open: false
        });
    }
    Submit()
    {
      const self = this;
      let welfare_idx = 0;
      let support_zone = self.state.data.support_zone, discount_type = 0;
      if( support_zone == 2 )
      {
        discount_type = this.state.data.select_discount_month;
      }
      if(self.state.data.select_welfare_item)
      {
        welfare_idx = self.state.data.select_welfare_item.idx;
      }

      let add_service =  self.state.data.select_add_item;
      let additional_service = [];
      if( add_service ) {
        for( let i = 0 ; i < add_service.length ; i++ )
        {
            additional_service.push(add_service[i].idx);
        }
      }
      //console.log(add_service_idx);

      let combined_discount = [];

      if( this.state.data.select_together_product != "" && this.state.data.select_together_line != "" )
      {
        combined_discount.push(this.state.data.select_together_product);
        combined_discount.push(this.state.data.select_together_line);
        let last = [];
        for( let i = 0 ; i < this.state.data.select_together_price.length ;i++) {
          let price = this.state.data.select_together_price[i];
          let piece = [];
          if( price.obj )
          {
            piece[0] = price.obj.name;
          } else {
            piece[0] = "";
          }

          piece[1] = -1;
          piece[2] = -1;
          if( this.state.data.select_focus_line_index != -1 )
          {
            if( i == this.state.data.select_focus_line_index )
            {
              piece[1] = 1;
            } else {
              piece[1] = 0;
            }
          }
          if( this.state.data.select_year_index != -1 )
          {
              piece[2] = this.state.data.select_year_index;
          }
          last.push(piece);
        }
        combined_discount.push(last);
      }

//      console.log(combined_discount);
//      return false;

      $.post('https://api.tfamily.co.kr/api/mobile/submit', {
            uk: self.state.data._pass_uk,
            device_idx: self.state.data._device_idx,
            fee_idx: self.state.data.select_price_item.idx,
            support: self.state.data.select_point_discount.data,
            installment_month: self.state.data.divide_month,
            discount_type: discount_type,
            sign_type: self.state.data.OptionTypeChar[self.state.data.OptionType-1],
            welfare_idx: welfare_idx,
            contract_discount_month: self.state.data.divide_discount_month,
            usim_idx: self.state.data.usimOption.index,
            insurance_idx : (self.state.data.select_insure_item) ? self.state.data.select_insure_item.idx : null,
            appl_type: self.appl_type,
            color: self.state.data.colorname,
            additional_service: additional_service.join(),
            card_0_idx: (self.state.data.select_prediscount_card) ? self.state.data.select_prediscount_card.idx : 0,
            card_1_idx: (self.state.data.select_postdiscount_card) ? self.state.data.select_postdiscount_card.idx : 0,
            combined_discount: JSON.stringify(combined_discount),
            subsidy: self.state.data.subsidy_price
      },function() {
        if( self.appl_type == 'C'){
          if( getiOS() )
          {
            window.webkit.messageHandlers.moreAction.postMessage('http://pf.kakao.com/_xnZxcxej/chat');
          } else {
            var newWin = window.open('http://pf.kakao.com/_xnZxcxej/chat');
            if(!newWin || newWin.closed || typeof newWin.closed=='undefined')
            {
              alert('팝업이 블록되었습니다. 블록 차단해주세요.');
            }
          }
        } else {

          if( getiOS() )
          {
              window.webkit.messageHandlers.moreAction.postMessage('tel:15995168');
          } else {
              var newWin = window.open('tel:15995168');
          }

        }
      });

    }
    render()
    {
        const self = this;
        return (
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-md mb0">
                    <div className="popupPadding pr45">
                        <div className="md-popup-header"> &nbsp;안내</div>
                        <div className="md-popup-content pt15 pb15">

                            {(self.appl_type=='C') ?
                              <div className="text-center">
                                <h4>채팅 상담을 진행합니다.</h4>
                                <br/>
                                <div className="text-center">
                                  <div>카카오톡 플러스 친구 "T패밀리몰"을 검색하시거나<br/> 아래 버튼 클릭 시 카카오톡으로 연결됩니다.</div>
                                </div>
                                <br/>
                                <a onClick={()=>{self.Submit()}} className="btn btn-default btn-lg">채팅상담 진행</a>
                              </div>
                            :
                              <div className="text-center">
                                <h4>전화 상담을 진행합니다.</h4>
                                <br/>
                                <div className="text-center">
                                  <div>전화 상담 대표번호 <b>1599-5168</b> 로 전화주시면 친절히 상담 드리겠습니다</div>
                                </div>
                                <br/>
                                <a onClick={()=>{self.Submit()}} className="btn btn-default btn-lg">전화상담 진행</a>
                              </div>
                            }

                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}
